import WheelEfficiencyLabel from './WheelEfficiencyLabel'

export default WheelEfficiencyLabel
